// Content Platform — ACTIVE block render registry (Phase 0). Maps a block `type` to its React
// component. This is the ONLY place that decides what is renderable. `faq` is intentionally ABSENT
// (schema-ready but inactive); an unknown/inactive type therefore resolves to undefined and
// BlockRenderer renders nothing (fail-closed) — though the build-time validator prevents such
// content from ever shipping.

import { BLOCK_TYPES } from '../../../content/blocks/types';
import Hero from './Hero';
import Intro from './Intro';
import RichText from './RichText';
import FeatureGrid from './FeatureGrid';
import Steps from './Steps';
import Media from './Media';
import Cta from './Cta';
import RelatedContent from './RelatedContent';

export const ACTIVE_BLOCKS = Object.freeze({
  [BLOCK_TYPES.HERO]: Hero,
  [BLOCK_TYPES.INTRO]: Intro,
  [BLOCK_TYPES.RICH_TEXT]: RichText,
  [BLOCK_TYPES.FEATURE_GRID]: FeatureGrid,
  [BLOCK_TYPES.STEPS]: Steps,
  [BLOCK_TYPES.MEDIA]: Media,
  [BLOCK_TYPES.CTA]: Cta,
  [BLOCK_TYPES.RELATED_CONTENT]: RelatedContent,
  // [BLOCK_TYPES.FAQ]: intentionally NOT registered (schema-ready but inactive).
});
